import React from 'react';
import { TermsOfService, PrivacyPolicy, RiskDisclaimer } from './components/legal';
import { Version, AppErrorBoundary } from './components/common';
import FeatureGuard from './components/common/FeatureGuard';
import { Support, About, TradingPhilosophy, LandingPage, Pricing, WaitlistPage } from './components/pages';
import { SignUp, Login, ForgotPassword } from './components/auth';
import NTBChatView from './components/CopilotChatView/CopilotMainView';
import AdminView from './components/AdminView/AdminView';
import TraderJournalView from './components/TraderJournalView/TraderJournalView';

// Common routes that appear in multiple places
export const commonRoutes = [
  { path: '/terms', element: <TermsOfService /> },
  { path: '/privacy', element: <PrivacyPolicy /> },
  { path: '/risk-disclaimer', element: <RiskDisclaimer /> },
  { path: '/version', element: <Version /> },
  { path: '/support', element: <Support /> },
  { path: '/about', element: <About /> },
  { path: '/trading-philosophy', element: <TradingPhilosophy /> },
  { path: '/waitlist', element: <WaitlistPage /> },
];

// Routes for authenticated users
export const authenticatedRoutes = [
  ...commonRoutes,
  {
    path: '/trader-journal',
    element: (
      <FeatureGuard feature="journalPage">
        <TraderJournalView />
      </FeatureGuard>
    ),
  },
  { path: '/*', element: <AppErrorBoundary><NTBChatView /></AppErrorBoundary> },
];

// Routes for admin users
export const adminRoutes = [
  { path: '/admin', element: <AdminView /> },
  ...authenticatedRoutes,
];

// Routes for unauthenticated users
export const unauthenticatedRoutes = [
  { path: '/', element: <LandingPage /> },
  { path: '/signup', element: <SignUp /> },
  { path: '/login', element: <Login /> },
  { path: '/forgot-password', element: <ForgotPassword /> },
  { path: '/pricing', element: <Pricing /> },
  ...commonRoutes,
];

// Routes for email verification
export const verificationRoutes = [
  { path: '/version', element: <Version /> },
]; 